<template>
  <div class="detail_supplyChain_box">
    <div class="search_tips_box" v-show="ishowSearchDetail">
      <div class="tips_box_header">
        <div class="close_btn" @click="ishowSearchDetail = false">
          <i class="iconfont icon-cuowu"></i>
        </div>
      </div>
      <div class="tips_box_content">
        <div class="tips_content_list">
          <div class="tips_content_list_label">
            {{ $t("Relationship.RecentTradeDate") }}
          </div>
          <div class="tips_content_list_value">
            {{ relationshipSearch.recent }}
          </div>
        </div>
        <div class="tips_content_list">
          <div class="tips_content_list_label">
            {{ $t("Relationship.TradeRelatedCompanies") }}
          </div>
          <div class="tips_content_list_value">
            {{ relationshipSearch.trade }}
          </div>
        </div>
        <div class="tips_content_list">
          <div class="tips_content_list_label">
            {{ $t("Relationship.IndustryCode") }}
          </div>
          <div class="tips_content_list_value">
            {{ relationshipSearch.indusyry }}
          </div>
        </div>
      </div>
      <div class="tips_box_product">
        <div class="tips_box_product_title">
          {{ $t("Relationship.TradeRelatedProductTOP10") }}
        </div>
        <div
          class="tips_box_product_list"
          v-for="(item, index) in relationshipSearch.topList"
          :key="index"
        >
          {{ item.productName }}
        </div>
      </div>
    </div>
    <div ref="chartCon" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import { getSupplyChain } from "@/api/companyApi.js";

export default {
  name: "",
  props: {
    detailInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    relationshipSearch: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},

  data() {
    return {
      myChart: null,
      data: {
        links: [],
        nodes: [],
      },
      links: [
        {
          source: "APPLE INC.",
          target: "Buyer: APPLE COLOMBIA SAS",
          value: 41781,
        },
        {
          source: "APPLE INC.",
          target: "Buyer: APPLE COLOMBIA S A S",
          value: 6120,
        },
        {
          source: "APPLE INC.",
          target: "Buyer: GOERTEK TECHNOLOGY VINA COMPANY LIMITED",
          value: 3823,
        },
        {
          source: "APPLE INC.",
          target: "Buyer: INGRAM MICRO S.A.C.",
          value: 1298,
        },
        {
          source: "APPLE INC.",
          target: "Buyer: DIGICENTER S.A.",
          value: 611,
        },
        {
          source: "APPLE INC.",
          target: "Buyer: SAMSUNG DISPLAY VIETNAM CO., LTD.",
          value: 325,
        },
        {
          source: "APPLE INC.",
          target:
            "Buyer: UNIVERSAL SCIENTIFIC INDUSTRIAL VIETNAM COMPANY LIMITED",
          value: 288,
        },
        {
          source: "APPLE INC.",
          target: "Buyer: GOERTEK ELECTRONICS VIETNAM COMPANY LIMITED",
          value: 133,
        },
        {
          source: "APPLE INC.",
          target: "Buyer: FUTURE INNOVATION VIET NAM COMPANY LIMITED",
          value: 77,
        },
        {
          source: "APPLE INC.",
          target: "Buyer: NEW WING INTERCONNECT TECHNOLOGY (BAC GIANG) CO.,LTD",
          value: 55,
        },
        {
          source: "Supplier: FOXCONN HON HAI TECHNOLOGY INDIA MEGA DEVELOPMENT",
          target: "APPLE INC.",
          value: 6381,
        },
        {
          source: "Supplier: GOERTEK TECHNOLOGY VINA COMPANY LIMITED",
          target: "APPLE INC.",
          value: 5614,
        },
        {
          source: "Supplier: APPLE COLOMBIA SAS",
          target: "APPLE INC.",
          value: 3205,
        },
        {
          source: "Supplier: BYD ELECTRONICS (VIETNAM) COMPANY LIMITED",
          target: "APPLE INC.",
          value: 2880,
        },
        {
          source: "Supplier: PEGATRON TECHNOLOGY INDIA PRIVATE LIMITED",
          target: "APPLE INC.",
          value: 2559,
        },
        {
          source: "Supplier: APPLE INDIA PRIVATE LIMITED",
          target: "APPLE INC.",
          value: 863,
        },
        {
          source: "Supplier: INB ELECTRONICS LIMITED",
          target: "APPLE INC.",
          value: 214,
        },
        {
          source: "Supplier: FOXTEQ SERVICES INDIA PRIVATE LIMITED",
          target: "APPLE INC.",
          value: 147,
        },
        {
          source:
            "Supplier: FOXLINK INTERNATIONAL INC C/O FUGANG ELECTRONIC DONGGUAN CO LTD",
          target: "APPLE INC.",
          value: 66,
        },
        {
          source: "Supplier: LG DISPLAY VIETNAM HAIPHONG COMPANY LIMITED",
          target: "APPLE INC.",
          value: 56,
        },
      ],
      nodes: [
        {
          name: "APPLE INC.",
        },
        {
          name: "Buyer: APPLE COLOMBIA S A S",
        },
        {
          name: "Buyer: APPLE COLOMBIA SAS",
        },
        {
          name: "Buyer: DIGICENTER S.A.",
        },
        {
          name: "Buyer: FUTURE INNOVATION VIET NAM COMPANY LIMITED",
        },
        {
          name: "Buyer: GOERTEK ELECTRONICS VIETNAM COMPANY LIMITED",
        },
        {
          name: "Buyer: GOERTEK TECHNOLOGY VINA COMPANY LIMITED",
        },
        {
          name: "Buyer: INGRAM MICRO S.A.C.",
        },
        {
          name: "Buyer: NEW WING INTERCONNECT TECHNOLOGY (BAC GIANG) CO.,LTD",
        },
        {
          name: "Buyer: SAMSUNG DISPLAY VIETNAM CO., LTD.",
        },
        {
          name: "Buyer: UNIVERSAL SCIENTIFIC INDUSTRIAL VIETNAM COMPANY LIMITED",
        },
        {
          name: "Supplier: APPLE COLOMBIA SAS",
        },
        {
          name: "Supplier: APPLE INDIA PRIVATE LIMITED",
        },
        {
          name: "Supplier: BYD ELECTRONICS (VIETNAM) COMPANY LIMITED",
        },
        {
          name: "Supplier: FOXCONN HON HAI TECHNOLOGY INDIA MEGA DEVELOPMENT",
        },
        {
          name: "Supplier: FOXLINK INTERNATIONAL INC C/O FUGANG ELECTRONIC DONGGUAN CO LTD",
        },
        {
          name: "Supplier: FOXTEQ SERVICES INDIA PRIVATE LIMITED",
        },
        {
          name: "Supplier: GOERTEK TECHNOLOGY VINA COMPANY LIMITED",
        },
        {
          name: "Supplier: INB ELECTRONICS LIMITED",
        },
        {
          name: "Supplier: LG DISPLAY VIETNAM HAIPHONG COMPANY LIMITED",
        },
        {
          name: "Supplier: PEGATRON TECHNOLOGY INDIA PRIVATE LIMITED",
        },
      ],
      companyList: [],

      ishowSearchDetail: false,
    };
  },

  watch: {
    echartsData: {
      handler(val) {
        if (val) {
          this.initEcharts();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
    // this.$nextTick(() => {
    //   this.initEcharts();
    // });
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    getData() {
      getSupplyChain({
        id3a: this.$route.query.id3a,
        companyName: this.detailInfo?.base?.companyName,
      })
        .then((result) => {
          let data = result;
          if (data.code == 200) {
            const listNode = data.data.nodes;
            let arr = [];
            const listLinks = data.data.links;
            this.companyList = data.data.nodes;
            this.$emit("getCompanyList", this.companyList);
            let arrLink = [];

            listNode.forEach((item) => {
              const pobj = { name: item.nameEn };
              arr.push(pobj);
            });
            this.nodes = arr;

            listLinks.forEach((item, index) => {
              const obj = {
                source: item.sourceEn,
                target: item.targetEn,
                value: item.value,
              };
              arrLink.push(obj);
            });
            this.links = arrLink;
            this.initEcharts();
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },

    initEcharts() {
      if (!this.myChart) {
        this.myChart = this.$echarts.init(this.$refs.chartCon, null, {
          renderer: "svg",
        });
      }
      const option = {
        grid: {
          left: "0%", // 调整这个数值来控制图表在容器中的左侧位置
          // 其他 grid 相关设置
        },
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        series: [
          {
            type: "sankey",
            data: this.nodes,
            links: this.links,
            emphasis: {
              focus: "adjacency",
            },
            levels: [
              {
                depth: 0,
                itemStyle: {
                  color: "#fbb4ae",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 1,
                itemStyle: {
                  color: "#b3cde3",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 2,
                itemStyle: {
                  color: "#ccebc5",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 3,
                itemStyle: {
                  color: "#decbe4",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
            ],
            lineStyle: {
              curveness: 0.5,
            },
          },
        ],
      };
      this.myChart.setOption(option);
      this.myChart.getZr().on("click", (event) => {
        // 第三层文字点击事件
        // encodeURIComponent
        let id = this.companyList.find(
          (item) => item.nameEn == event.topTarget.style.text,
        )?.aaaId;
        let name = this.companyList.find(
          (item) => item.nameEn == event.topTarget.style.text,
        )?.name;
        if (id) {
          getSupplyChain({
            id3a: id,
            companyName: encodeURIComponent(name),
          }).then((result) => {
            // let data = JSON.parse(crypto.decrypt(result));
            let data = result;
            if (data.code == 200) {
              const listNode = data.data.nodes;
              let arr = [];
              const listLinks = data.data.links;
              this.companyList = data.data.nodes;
              this.$emit("getCompanyList", this.companyList);
              let arrLink = [];

              listNode.forEach((item) => {
                const pobj = { name: item.nameEn };
                arr.push(pobj);
              });
              this.nodes = arr;

              listLinks.forEach((item, index) => {
                const obj = {
                  source: item.sourceEn,
                  target: item.targetEn,
                  value: item.value,
                };
                arrLink.push(obj);
              });
              // this.linkpre = arrLink
              this.links = arrLink;
              // this.findLink()
              this.myChart.getZr().off("click");
              this.initEcharts();
            }
          });
        }
      });
    },
    resizeChart() {
      // 调用 ECharts 实例的 resize 方法，动态调整图表大小
      if (this.myChart) {
        this.myChart.resize();
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
.detail_supplyChain_box {
  width: 100%;
  height: 100%;
  position: relative;
}

.search_tips_box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  transition: all 0.3s ease;
  padding: 14px;
  z-index: 8;
  width: auto;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
}
.tips_box_header {
  width: 100%;
  height: 1px;
  position: relative;
}
.close_btn {
  position: absolute;
  top: -23px;
  right: -23px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ff6a6a;
  text-align: center;
  line-height: 18px;
  cursor: pointer;
}
.close_btn i {
  color: #fff;
}
.tips_box_content {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #cccccc;
  overflow: hidden;
}

.tips_content_list {
  display: flex;
}
.tips_content_list + .tips_content_list {
  border-top: 1px solid #cccccc;
}
.tips_content_list_label {
  width: 220px;
  font-family: "Arial Bold";
  padding: 8px 10px;
  font-size: 14px;
  color: #1a2332;
  line-height: 16px;
  text-align: left;
  background: #f3f3f3;
}
.tips_content_list_value {
  flex: 1;
  min-width: 80px;
  max-width: 160px;
  padding: 8px 10px;
  font-size: 14px;
  color: #1a2332;
  line-height: 16px;
  text-align: left;
}
.tips_box_product {
  margin-top: 10px;
  width: auto;
  height: auto;
  border-radius: 4px;
  border: 1px solid #cccccc;
}
.tips_box_product_title {
  width: auto;
  height: 40px;
  padding: 10px 8px;
  font-family: "Arial Bold";
  background: #f3f3f3;
  border-radius: 4px 4px 0px 0px;
  font-weight: normal;
  font-size: 14px;
  color: #1a2332;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  border-bottom: 1px solid #cccccc;
  box-sizing: border-box;
}
.tips_box_product_list {
  min-height: 40px;
  padding: 10px 8px;
  font-size: 14px;
  color: #1a2332;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  box-sizing: border-box;
}
.tips_box_product_list + .tips_box_product_list {
  border-top: 1px solid #cccccc;
}

@media (max-width: 1920px) {
  .search_tips_box {
    padding: 12px;
  }
  .close_btn {
    top: -20px;
    right: -20px;
    width: 16px;
    height: 16px;
    line-height: 16px;
  }
  .close_btn i {
    font-size: 14px;
  }
  .tips_content_list_label {
    width: 190px;
    padding: 6px 8px;
    font-size: 12px;
    line-height: 14px;
  }
  .tips_content_list_value {
    padding: 6px 8px;
    font-size: 12px;
    line-height: 14px;
  }
  .tips_box_product {
    margin-top: 8px;
  }
  .tips_box_product_title {
    height: 30px;
    padding: 8px 6px;
    font-size: 12px;
    line-height: 14px;
  }
  .tips_box_product_list {
    min-height: 30px;
    padding: 8px 6px;
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
